<template>
  <div class="integration-accounts">
    <template v-if="isLoading">
      Loading ...
    </template>
    <template v-else>
      <company-object-sidebar
        object-type="Account"
        :company-objects="accounts"
        :value="selectedAccount"
        @input="selectAccount" />
      <div class="editor">
        <div class="editor-actions">
          <button
            :disabled="isBusy"
            @click="doSomething">
            Do Something
          </button>
        </div>
        <schema-form
          v-if="selectedAccountJson"
          v-model="selectedAccountJson"
          :errors="selectedAccountErrors"
          :schema="schemas.IntegrationAccount"
          :all-schemas="schemas" />
      </div>
    </template>
  </div>
</template>

<script>
  import CompanyObjectSidebar from '@/components/reports/config/common/CompanyObjectSidebar.vue'
  import SchemaForm from '@/views/internal/schema_form/SchemaForm.vue'

  export default {
    name: 'IntegrationAccounts',
    components: {
      CompanyObjectSidebar,
      SchemaForm,
    },
    data () {
      return {
        isLoading: false,
        isBusy: false,
        accounts: [],
        selectedAccount: null,
        selectedAccountJson: null,
        selectedAccountErrors: [],
        schemas: null,
      }
    },
    mounted () {
      this.initialLoad()
    },
    methods: {
      selectAccount (account) {
        this.selectedAccount = account
        this.selectedAccountJson = this.accounts?.find(
          (a) => a.key == this.selectedAccount
        )
        this.selectedAccountErrors = []
      },
      async doSomething () {
        this.isBusy = true
        let response = await this.$apis.integrations.doSomething(
          this.selectedAccountJson
        )
        console.log('Do something response', response)
        this.selectedAccountErrors = response.errors || []
        this.isBusy = false
      },
      async initialLoad () {
        this.isLoading = true
        let accountsFuture = this.$apis.integrations.listIntegrationAccounts()
        let apiSpecFuture = this.$apis.app.getExporterApiSpec()
        this.accounts = await accountsFuture
        this.schemas = (await apiSpecFuture).components.schemas
        this.isLoading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
.integration-accounts {
  display: flex;
}
.editor {
  display: flex;
  flex-direction: column;
}
.editor-actions {
  display: flex;
}
</style>
